import { Link, createFileRoute } from "@tanstack/react-router";
import { confirmNewsletterSubscription } from "@/lib/api";

export const Route = createFileRoute("/confirm")({
  validateSearch: (search: Record<string, unknown>) => ({
    token: (search.token as string) || "",
  }),
  loaderDeps: ({ search }) => ({ token: search.token }),
  loader: async ({ deps }) => {
    if (!deps.token) return { confirmed: false };
    const result = await confirmNewsletterSubscription({ data: deps.token });
    return result;
  },
  component: ConfirmPage,
});

function ConfirmPage() {
  const { confirmed } = Route.useLoaderData();

  if (confirmed) {
    return (
      <div className="mx-auto max-w-lg px-4 py-24 text-center">
        <div className="mx-auto mb-4 flex size-12 items-center justify-center rounded-full bg-green-100 text-green-600">
          <svg
            className="size-6"
            viewBox="0 0 20 20"
            fill="currentColor"
            aria-hidden="true"
          >
            <path
              fillRule="evenodd"
              d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z"
              clipRule="evenodd"
            />
          </svg>
        </div>
        <h1 className="text-polaris-navy mb-3 text-2xl font-semibold tracking-tight">
          You're confirmed!
        </h1>
        <p className="mb-6 text-gray-600">
          Thanks for subscribing. You'll receive our next newsletter in your
          inbox.
        </p>
        <Link
          to="/"
          className="text-sm font-medium text-gray-600 transition-colors hover:text-gray-900"
        >
          Go to Data First Jobs →
        </Link>
      </div>
    );
  }

  return (
    <div className="mx-auto max-w-lg px-4 py-24 text-center">
      <h1 className="text-polaris-navy mb-3 text-2xl font-semibold tracking-tight">
        This link is invalid or has expired
      </h1>
      <p className="mb-6 text-gray-600">
        The confirmation link may have already been used or timed out.
      </p>
      <Link
        to="/newsletter"
        className="text-sm font-medium text-gray-600 transition-colors hover:text-gray-900"
      >
        Subscribe again →
      </Link>
    </div>
  );
}
